import React, { Component } from 'react';
import user2 from '../images/user2.png';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';


class menu extends Component {

    constructor(props){
        super(props);
        this.state = {
            menuClass: false,
            programID: 0,
            showProgram: false

        }
    }

    
    setMenuClass = (state) => {
        this.setState({menuClass: state}); 
    };

    openMenu = () => {
       this.setMenuClass(!this.state.menuClass)
    };

    getQueryProgram = () => {
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/queryProgram`, {
            transactionId: new Date().getTime(),
            msisdn: this.props.number
        }, { headers: {"Authorization": "Bearer " + this.props.token } })
        .then(res => {
            if(res.data.code == "P00"){
                if(res.data.program != null){
                    this.setState({programID: res.data.program[0].programID});                    
                    this.setState({showProgram: true});                    
                }
                else {
                    this.setState({showProgram: false});
                }
            }
            else {
                
            }

        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao carregar as recargas programadas!",
                type: 'error'
            })
        })
    }

    deleteProgram = (event) => {
        event.preventDefault();
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/deleteProgram`, {
            transactionId: new Date().getTime(),
            msisdn: this.props.number,
            programID: this.state.programID
        }, { headers: {"Authorization": "Bearer " + this.props.token } })
        .then(res => {
            if(res.data.code == "P00"){
                Swal.fire({
                    title: 'Cancelado!',
                    text: "Recarga programada cancelada, com sucesso!",
                    type: 'success'
                })
                this.setState({showProgram: false});
            }
            else {
                Swal.fire({
                    title: 'Erro!',
                    text: res.data.msg,
                    type: 'error'
                })
                this.setState({showProgram: true});
            }

        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao cancelar as recargas programadas!",
                type: 'error'
            })
            this.setState({showProgram: true});
        })
    }

    componentDidMount() {
        this.getQueryProgram();
    }

    render() {
        const showProgram = this.state.showProgram ? 'showProgram' : '';

        return (
            <div id="mySidenav" className={this.state.menuClass ? 'active' : ''}>
                <span className="closebtn" onClick={this.openMenu}>×</span>
                <ul>
                    <div>
                        <li id="li1">
                            <img src={user2}/>
                        </li>
                        <li id="li2" >
                            <a id="lblRecebeNumeroTelefone">{this.props.numberFormat}</a>
                        </li>
                    </div>
                    <li id="li3"></li>
                    <ul>
                        <Link 
                            to={{
                                pathname: "/MeusDados" ,
                                state:{
                                    numberFormat: this.props.numberFormat,
                                    number: this.props.number,
                                    token: this.props.token
                                }
                            }}
                        ><li><a href="#">MEUS DADOS</a></li></Link>
                        <Link 
                            to={{
                                pathname: "/Recarga" ,
                                state:{
                                    numberFormat: this.props.numberFormat,
                                    number: this.props.number,
                                    token: this.props.token
                                }
                            }}
                        ><li><a href="#">RECARGA</a></li></Link>
                        <Link to="/"><li><a href="#">SAIR</a></li></Link>
                        <li className={`btn-program ${showProgram}`}><a onClick={this.deleteProgram} href="#">CANCELAR MINHA RECARGA PROGRAMADA</a></li>
                    </ul>
                    
                </ul>
            </div>
        )
    }
}

export default menu; // Don’t forget to use export default!